import { extendTheme } from "@chakra-ui/react";

import { buttonStyles } from "./components/button";
import { breakpoints } from "./foundations/breakpoints";
import { inputStyles } from "./components/input";

export default extendTheme(buttonStyles, inputStyles, { breakpoints });
